import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { InterestedPartiesService } from "./interestedparties.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { InterestedParty } from "../../api-models/InterestedParty";
import { InterestedPartiesMainComponent } from "./interestedparties.main.component";

@Component({
    selector: "app-interestedparties",
    templateUrl: "./interestedparties.component.html",
    styleUrls: ["interestedparties.component.scss"],
    standalone: false
})
export class InterestedPartiesComponent extends BaseMaterialDatatableComponent<InterestedParty> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: InterestedParty[] = [];

    constructor(private interestedPartiesService: InterestedPartiesService, private translateService: TranslateService, private modalService: BsModalService, private alertService: AlertService, parent: InterestedPartiesMainComponent) {
        super({
            stateSaveConfig: {
                stateSaveMode: interestedPartiesService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_interestedparties_list",
            },
            sortState: {
                active: "created",
                direction: "desc",
            },
            displayedColumns: ["name", "address", "contact", "notes", "created", "updated", "actions"],
            listService: interestedPartiesService,
        });

        this.UTCDATEFORMAT = this.interestedPartiesService.UTCDATEFORMAT;
    }

    deleteInterestedParty(id: string) {
        const initialState = {
            title: this.translateService.instant("interestedparties.list.delete.title"),
            message: this.translateService.instant("interestedparties.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.interestedPartiesService.deleteInterestedParties(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("interestedparties.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }
}
